import FooterView from "@wine2trace/ui/Footer";
import useLabels from "../../hooks/useLabels";

const Footer = () => {
  const [getLabel] = useLabels();
  return <FooterView links={getLabel("footer") || []} />;
};

export default Footer;
